<template>
  <modal title="Security Questions" width="45" :showModal="showModal" @close-modal="$emit('close-modal')">
    <div class="flex flex-col" v-loading="loading">
      <p class="text-base my-3">
        Turn on security questions for added sign-in protection to your account. 
        As the root admin, you can also enforce this across your organization, thus every user has it turned on by default.
      </p>

      <div class="flex gap-2">
        <el-switch
          v-model="security"
          active-color="#FCC210"
          inactive-color="#EEEEEE"
        />
        <p>Security Questions Enabled</p>
      </div>

      <div class="flex align-middle">
        <base-checkbox label="Enforce use of security questions for all users within this organization."></base-checkbox>
        <p class="text-lightGrey"></p>
      </div>

      <hr class="my-3"/>

      <h3 class="text-base font-semibold">Questions and Answers <span class="text-lightGrey font-normal "> (Max 3) </span></h3>
      <div>
        <div class="flex justify-between p-2 my-3 rounded-sm bg-primary-white align-middle">
          <div class="text-sm ">
            <p>Question 1:</p>
            <p>WHAT IS YOUR MOTHERS MAIDEN NAME ?</p>
          </div>
          <span>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14ZM6.99998 12.7273C10.1631 12.7273 12.7273 10.1631 12.7273 7C12.7273 3.83691 10.1631 1.27273 6.99998 1.27273C3.83689 1.27273 1.27271 3.83691 1.27271 7C1.27271 10.1631 3.83689 12.7273 6.99998 12.7273ZM4.90447 9.99548L6.99995 7.9L9.09543 9.99548L9.99538 9.09553L7.8999 7.00005L9.99538 4.90457L9.09543 4.00462L6.99995 6.10009L4.90447 4.00462L4.00452 4.90457L6.09999 7.00005L4.00452 9.09553L4.90447 9.99548Z" fill="#383F51"/>
              </svg>
          </span>
        </div>
        <div class="flex relative">
          <input type="text" class="input">
          <span class="absolute" style="right: 10px; top:10px">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.75 4.375L14.625 1.25L2.125 13.75L0.875 18.125L5.25 16.875L17.75 4.375ZM12.125 3.75L15.25 6.875L12.125 3.75ZM2.125 13.75L5.25 16.875L2.125 13.75Z" stroke="#09B78A" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>

        </div>

        <div class="my-2">
          <div class="new-user-form__single-input-wrapper">
          <label for="new">New question</label>
          <input type="text" v-model="question" class="input">
            
          </div>
          
          <div class="relative flex">
            <input type="text" class="input " v-model="answer"  id="new" placeholder="--Answer Here--">
            <span class="absolute" style="right: 30px; top: 10px;">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.55556 14H12.4444C12.857 14 13.2527 13.8361 13.5444 13.5444C13.8361 13.2527 14 12.857 14 12.4444V3.88889L10.1111 0H1.55556C1.143 0 0.747335 0.163888 0.455612 0.455612C0.163888 0.747335 0 1.143 0 1.55556V12.4444C0 12.857 0.163888 13.2527 0.455612 13.5444C0.747335 13.8361 1.143 14 1.55556 14ZM3.11111 1.55556H6.22222V3.11111H7.77778V1.55556H9.33333V4.66667H3.11111V1.55556ZM3.11111 7.77778H10.8889V12.4444H3.11111V7.77778Z" fill="#FCC210"/>
                  </svg>
            </span>
            <span class="absolute " style="right:  10px; top: 10px;">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14ZM6.99998 12.7273C10.1631 12.7273 12.7273 10.1631 12.7273 7C12.7273 3.83691 10.1631 1.27273 6.99998 1.27273C3.83689 1.27273 1.27271 3.83691 1.27271 7C1.27271 10.1631 3.83689 12.7273 6.99998 12.7273ZM4.90447 9.99548L6.99995 7.9L9.09543 9.99548L9.99538 9.09553L7.8999 7.00005L9.99538 4.90457L9.09543 4.00462L6.99995 6.10009L4.90447 4.00462L4.00452 4.90457L6.09999 7.00005L4.00452 9.09553L4.90447 9.99548Z" fill="#383F51"/>
              </svg>
            </span>
          </div>
        </div>

        <a href="#" class="text-primary-yellow my-5 font-normal">Add Question</a>
      </div>
      <hr class="my-3">
      <div class="flex flex-col my-2">
        <label for="current">Current Password</label>
        <base-input
          type="password"
          placeholder="Enter Your Password"
          v-model="password"
        >
          <template v-slot:icon>
            <svg
              width="16"
              height="18"
              viewBox="0 0 16 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.45118 10.8262V12.7355M1.58551 7.64408V17.1905H15.3169V7.64408H1.58551ZM4.08212 7.64408C4.08212 3.8255 4.08212 1.27979 8.45118 1.27979C12.8202 1.27979 12.8202 3.8255 12.8202 7.64408H4.08212Z"
                stroke="#FCC210"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </template>
        </base-input>
      </div>
      <div class="flex items-center mt-8 justify-between">
        <div class="cursor-pointer" @click="$router.go(-1)">
          <p>Cancel</p>
        </div>
        <primary-button buttonText="Save" @click="updateSecurityQuestion" />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    creatingGroup: {
        type: Boolean,
        required: false,
    },
    isButtonDisabled: {
        type: Boolean,
        required: false,
    },
    refreshGroups: {
        type: Boolean,
        required: false,
    },
  },
  data() {
    return {
      questions: [
      'help1',
      'help',
      'help3',
      ],
      question: '',
      password: '',
      answer: '',
      security: false,
      selectedUsers: [],
      selectedUserId: "",
      showOptions: false,
      role: "",
      roles: [],
      filterQuery: "",
      loading: false,
    };
  },
  computed: {
     userEmail(){
      return this.$store.state.authentication.user.email;
    }
  },
  methods: {
    async updateSecurityQuestion(){
      let requestObj = {
        email: this.userEmail,
         password: this.password,
        securityQuestion: this.question, 
        answer: this.answer
      }
      try {
        const response = await this.$_updateSecurityQuestion( requestObj);
        console.log(response)
      } catch (error){
        this.handleError(error)
      }
    }
  }
};
</script>

<style scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}
.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
</style>
